import { localizationRouteComponent } from "@/globals";
import {
  UserManager,
  UserManagerSettings,
  WebStorageStateStore
} from "oidc-client-ts";

const userManagerSettings: UserManagerSettings = {
  client_id: "F59A84B4-6E6B-4678-97A0-11C0F6E0719F",
  authority: import.meta.env.VITE_APP_INDIVIDUALS_URL,
  scope: "openid offline_access profile roles email",
  automaticSilentRenew: true,
  includeIdTokenInSilentRenew: true,
  includeIdTokenInSilentSignout: false,
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  redirect_uri: "/",
  post_logout_redirect_uri: `${
    window.location.origin + localizationRouteComponent
  }/sign-out/callback`,
  extraTokenParams: {
    environment: import.meta.env.VITE_APP_HOSTNAME
  },
  metadata: {
    authorization_endpoint: `${import.meta.env.VITE_APP_INDIVIDUALS_URL}/member/connect/authorize`,
    token_endpoint: `${import.meta.env.VITE_APP_INDIVIDUALS_URL}/member/connect/token`
  }
};

export const userManagerSettingsGoogleSSO: UserManagerSettings = {
  client_id: "52A25F89-0EDB-4E23-AD45-5B026D103E2E",
  authority: import.meta.env.VITE_APP_INDIVIDUALS_URL,
  scope: "openid offline_access profile roles email",
  automaticSilentRenew: true,
  includeIdTokenInSilentRenew: true,
  includeIdTokenInSilentSignout: false,
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  redirect_uri: `${
    location.protocol + "//" + location.host + localizationRouteComponent
  }/sign-in/callback`,
  post_logout_redirect_uri: `${
    window.location.origin + localizationRouteComponent
  }/sign-out/callback`,
  extraTokenParams: {
    environment: import.meta.env.VITE_APP_HOSTNAME
  },
  response_mode: "fragment",
  metadata: {
    authorization_endpoint: `${import.meta.env.VITE_APP_INDIVIDUALS_URL}/member/connect/authorize`,
    token_endpoint: `${import.meta.env.VITE_APP_INDIVIDUALS_URL}/member/connect/token`
  }
};

export const userManagerSettingsOBO: UserManagerSettings = {
  client_id: "B81C2FC4-1F40-45DF-B4F9-8458EF26B515",
  authority: import.meta.env.VITE_OBO_AUTH_URL,
  scope: "openid offline_access profile roles email",
  automaticSilentRenew: true,
  includeIdTokenInSilentRenew: true,
  includeIdTokenInSilentSignout: false,
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  redirect_uri: `${
    location.protocol + "//" + location.host + localizationRouteComponent
  }/sign-in/callback/login/obo`,
  post_logout_redirect_uri: `${
    window.location.origin + localizationRouteComponent
  }/sign-out/callback`,
  extraQueryParams: {
    environment: import.meta.env.VITE_APP_HOSTNAME
  },
  response_mode: "fragment"
};

export const userManagerSettingsFunction: UserManagerSettings = {
  client_id: "7B4E8C2A-1D3F-4A5B-9E6C-8F7D2A1B3C4E",
  authority: import.meta.env.VITE_APP_INDIVIDUALS_URL,
  scope: "openid offline_access profile roles email",
  automaticSilentRenew: true,
  includeIdTokenInSilentRenew: true,
  includeIdTokenInSilentSignout: false,
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  // Function Health uses its own callback page to handle OTP verification flow
  redirect_uri: `${location.protocol + "//" + location.host + localizationRouteComponent}/sign-in/callback/function`,
  post_logout_redirect_uri: `${window.location.origin + localizationRouteComponent}/sign-out/callback`,
  extraTokenParams: {
    environment: import.meta.env.VITE_APP_HOSTNAME
  },
  response_mode: "fragment",
  metadata: {
    // Function Health uses its own authorization endpoint
    authorization_endpoint: `${import.meta.env.VITE_APP_INDIVIDUALS_URL}/member/connect/function`,
    token_endpoint: `${import.meta.env.VITE_APP_INDIVIDUALS_URL}/member/connect/token`
  }
};

export const userManager = new UserManager(userManagerSettings);
export const userManagerGoogleSSO = new UserManager(
  userManagerSettingsGoogleSSO
);

export const userManagerOBO = new UserManager(userManagerSettingsOBO);
export const userManagerFunction = new UserManager(userManagerSettingsFunction);

export async function getActiveUserManager() {
  const authType = sessionStorage.getItem("authType");
  switch (authType) {
    case "R":
      return userManager;
    case "G":
      return userManagerGoogleSSO;
    case "O":
      return userManagerOBO;
    case "F":
      return userManagerFunction;
  }

  // Account for session storage item not being set in some redirect cases
  if (await userManager.getUser()) {
    sessionStorage.setItem("authType", "R");
    return userManager;
  }
  if (await userManagerGoogleSSO.getUser()) {
    sessionStorage.setItem("authType", "G");
    return userManagerGoogleSSO;
  }
  if (await userManagerOBO.getUser()) {
    sessionStorage.setItem("authType", "O");
    return userManagerOBO;
  }
  if (await userManagerFunction.getUser()) {
    sessionStorage.setItem("authType", "F");
    return userManagerFunction;
  }
}
